import React, { FC, useEffect, useState, useRef } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { formatChartData, getChartOptions, generateLegend } from '../../../../services/widget-chart-service';
import { useTheme } from 'styled-components';
ChartJS.register(ArcElement, Tooltip, Legend, Title);

const DoughtnutComponent: FC<any> = ({
  labels,
  data,
  title,
  key
}) => {
  const theme: any = useTheme();
  const palette = theme?.palette ?? {};
  const cardStyle: React.CSSProperties = {
    backgroundColor: palette[10] ?? '#ffffff',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: theme?.isDark ? '0 1px 3px rgba(15, 23, 42, 0.35)' : '0 1px 3px rgba(15, 23, 42, 0.08)',
    border: `1px solid ${palette[300] ?? '#e2e8f0'}`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
    width: '100%',
  };
  const headingColor = palette[850] ?? '#0f172a';
  const emptyStateColor = palette[700] ?? '#6b7280';
  const emptyIconOpacity = theme?.isDark ? 0.5 : 0.3;
  const [chartData, setChartData] = useState<any>({ labels: [], datasets: [] });
  const legendRef = useRef<HTMLDivElement>(null);
  const chartRef = useRef<any>(null); // react-chartjs-2 не экспортирует точный тип рефа
  const chartOptions = getChartOptions(title, `${key}-doughnut-legend`);
  const updateData = () => {
    setChartData(
      formatChartData({
        labels,
        data,
      })
    );
  };

  useEffect(() => {
    updateData();
  }, [labels, data]);

  useEffect(() => {
    if (chartRef.current && legendRef.current) {
      legendRef.current.innerHTML = generateLegend(chartRef.current);
    }
  }, [chartData]);


  return (
    <div style={cardStyle}>
      {chartData.labels.length > 0 ? (
        <>
          <h3 style={{
            fontSize: '15px',
            fontWeight: '600',
            color: headingColor,
            textAlign: 'center',
            textTransform: 'uppercase',
            letterSpacing: '0.04em'
          }}>
            {title}
          </h3>
          <div style={{
            maxWidth: '260px',
            position: 'relative',
            height: '220px'
          }}>
            <Doughnut
              ref={chartRef}
              data={chartData}
              options={chartOptions}
            />
          </div>
          <div
            ref={legendRef}
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              gap: '8px',
              width: '100%'
            }} />
        </>
      ) : (
        <div style={{
          textAlign: 'center',
          color: emptyStateColor,
          fontSize: '14px'
        }}>
          <div style={{
            fontSize: '48px',
            marginBottom: '16px',
            opacity: emptyIconOpacity
          }}>
            📊
          </div>
          <p>No data available for chart.</p>
        </div>
      )}
    </div>
  );
};

export default DoughtnutComponent;
